import api from '../../../utils/api';

// Programs a student saved from the career-interests chat (shown again on their Results page)

export const fetchSavedPrograms = async () => {
  const response = await api.get('/api/saved-programs/');
  return Array.isArray(response?.data?.programs) ? response.data.programs : [];
};

export const saveProgram = async ({ course_name, fit_label = '', reason = '' }) => {
  const response = await api.post('/api/saved-programs/', { course_name, fit_label, reason });
  return response.data;
};

export const unsaveProgram = async (courseName) => {
  await api.delete('/api/saved-programs/', { params: { course_name: courseName } });
};
